/*
 * サブシステム名：配車帳票出力
 * 機能名：配車帳票出力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'

export default {
  name: 'HaishaOutput',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdRadioButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    conditions: {},
    chohyoSbt: '0',
    modeKengen: 0,
    // 表示制御
    dispCsvNm: '',
    dispPdfNm: '',
    page: 1,
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    tenkoMode: false,
    dispHacchusakiMode: false
  }),
  watch: {
    chohyoSbt: function () {
      if (this.chohyoSbt === '0') {
        this.tenkoMode = false
        this.dispHacchusakiMode = true
      } else if (this.chohyoSbt === '1') {
        this.tenkoMode = false
        this.dispHacchusakiMode = true
      } else if (this.chohyoSbt === '2') {
        this.tenkoMode = false
        this.dispHacchusakiMode = false
      } else if (this.chohyoSbt === '3') {
        this.tenkoMode = true
        this.dispHacchusakiMode = false
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      haishahyoList: 'DDMasters/mstHaishahyo',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    // 人員マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target &&
              (self.eigyoshoLockFlg || t.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 配車表フィルター
    filteredHaishaHyoList () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.haishahyoList.map(elem => {
        return {
          value: elem.haishahyoCd,
          text: `${elem.haishahyoCd}:${elem.haishahyoNm}`
        }
      })
      return defArray.concat(resultArray)
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'vwcmstsharyo', 'msttorihikisaki', 'msthaishahyo'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onCsvButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.Effects.loadStart()
      this.clearSummaryMessage()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispCsvNm = `配車一覧表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2plmr0110/CsvDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispCsvNm = `配車依頼書_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2plmr0120/CsvDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispCsvNm = `配車指示書_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2plmr0130/CsvDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispCsvNm = `点呼記録簿_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2ctlp1010/CsvDownload'
      }
      this.HttpClient
        .post(post, this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      console.log(e)
      this.Effects.loadStart()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispPdfNm = `配車一覧表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2plmr0110/PdfDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispPdfNm = `配車依頼書_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2plmr0120/PdfDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispPdfNm = `配車指示書_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2plmr0130/PdfDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispPdfNm = `点呼記録簿_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2ctlp1010/PdfDownload'
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })
    },
    clientValidate: function () {
      var msg
      if (!this.conditions.startDay) {
        this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (this.conditions.startDay && this.conditions.endDay) {
        msg = validators.compareDate(this.conditions.startDay, this.conditions.endDay)
        if (msg !== undefined) {
          this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.endDay[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    onClearButtonClick: function () {
      this.initBindVariables()
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      const initConditions = {
        startDay: filter.dateFormatter(new Date()),
        endDay: null,
        startEigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : null,
        endEigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : null,
        keikakuKakuteiFlg: false,
        startJininCd: null,
        endJininCd: null,
        startSharyoCd: null,
        endSharyoCd: null,
        startHaishahyoCd: null,
        endHaishahyoCd: null,
        startHacchusakiCd: null,
        endHacchusakiCd: null
      }
      this.conditions = Object.assign({}, initConditions)
      // 表示制御
      this.chohyoSbt = '0'
      this.tenkoMode = false
      this.dispHacchusakiMode = true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
